/**
 * @documental
 * @export Action
 * @name
 * Table.Actions.Action
 */
import { FC, ReactNode } from "react";

import { AccessibilityProps } from "../../../AccessibilityProps";
import { BaseProps } from "../../../BaseProps";
import { DataId } from "../../DataId";
import { IconColor, IconName } from "../../Icon";
import { ActionClickHandler } from "./ActionsInternal/ActionClickHandler";
import { ActionDisabledCallback } from "./ActionsInternal/ActionDisabledCallback";
import { ActionVisibilityCallback } from "./ActionsInternal/ActionVisibilityCallback";

/**
 * The `Action` component properties.
 */
export interface ActionProps extends BaseProps, Pick<AccessibilityProps, "aria-label"> {
  /**
   * @deprecated
   * The icon color. If not specified defaults to `"turquoise"`.
   */
  readonly color?: IconColor;

  /**
   * Function which called indicates whether the action is disabled.
   */
  readonly disabled?: ActionDisabledCallback;

  /**
   * The action icon.
   */
  readonly icon: IconName | ((id: DataId) => IconName);

  /**
   * Called when the action is clicked.
   */
  readonly onClick?: ActionClickHandler;

  /**
   * The action tooltip.
   */
  readonly tooltip: ReactNode | ((id: DataId) => ReactNode);

  /**
   * determines if the action is functional (blue) or destructive (red)
   * takes precedence over the color prop
   */
  readonly type?: "functional" | "destructive";

  /**
   * Function which called indicates whether the action is visible.
   */
  readonly visible?: ActionVisibilityCallback;
}

/**
 * Represents a single action which can be placed within the `Actions` column component.
 */
export const Action: FC<ActionProps> = () => {
  return null;
};
